import React__default from 'react';
import { useDayPicker } from '../useDayPicker.js';

/**
 * Render a dropdown to navigate between years in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function YearsDropdown(props) {
    const { components } = useDayPicker();
    return React__default.createElement(components.Dropdown, { ...props });
}

export { YearsDropdown };
